import { render } from "./AllExtracts.vue?vue&type=template&id=f4b5c506&scoped=true"
import script from "./AllExtracts.vue?vue&type=script&lang=js"
export * from "./AllExtracts.vue?vue&type=script&lang=js"

import "./AllExtracts.vue?vue&type=style&index=0&id=f4b5c506&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b5c506"]])

export default __exports__